import type { VaultFormField } from "../../lib/types";

/**
 * One credential input. The value never leaves the component in plaintext: the modal
 * encrypts it with the unlocked app-scoped key before it is stored.
 */
export function SecretVaultField({
  field,
  value,
  onChange,
}: {
  field: VaultFormField;
  value: string;
  onChange: (value: string) => void;
}) {
  const id = `vault-field-${field.name}`;
  return (
    <label htmlFor={id} className="block space-y-1">
      <span className="text-sm text-[var(--tj-text)]">
        {field.label}
        {field.required ? <span aria-hidden="true"> *</span> : null}
      </span>
      {field.type === "textarea" ? (
        <textarea
          id={id}
          value={value}
          placeholder={field.placeholder}
          onChange={(event) => onChange(event.target.value)}
          className="w-full rounded-lg border border-[var(--tj-border)] bg-[var(--tj-surface)] px-3 py-2 text-sm"
        />
      ) : (
        <input
          id={id}
          type={
            field.type === "password"
              ? "password"
              : field.type === "email"
                ? "email"
                : field.type === "url"
                  ? "url"
                  : "text"
          }
          value={value}
          placeholder={field.placeholder}
          autoComplete="off"
          onChange={(event) => onChange(event.target.value)}
          className="w-full rounded-lg border border-[var(--tj-border)] bg-[var(--tj-surface)] px-3 py-2 text-sm"
        />
      )}
    </label>
  );
}
